import React from "react"
import { Edit } from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import BarChartIcon from "@mui/icons-material/BarChart"
import ScheduleIcon from "@mui/icons-material/Schedule"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import Form from "./form"


function DeviceEdit(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]

    return (
        <Edit redirect="show" mutationMode="pessimistic" actions={<RecordActionsTabs subTabs={subTabs}/>}>
            <Form />
        </Edit>
    )
}

export default DeviceEdit
